import { NuvoBox } from '@nuvolo/nuux-core/components/NuvoBox';
import { TextArea } from 'devextreme-react/text-area';
import { NuvoTextField, type NuvoTextFieldProps } from '@nuvolo/nuux-core/components/NuvoTextField';
import React from 'react';
import type { NativeEventInfo } from 'devextreme/events';
import Styles from './Styles';
import TMMButton from '../TMMButton';
import FAIcon from '#/common/components/FAIcon';

export interface ActionInputProps extends NuvoTextFieldProps {
  icon: string;
  onAction: () => unknown;
  multiline?: boolean;
}

const ActionInput: React.FC<ActionInputProps> = ({
  icon,
  onAction,
  disabled,
  multiline,
  ...txtProps
}) => {
  const onEnterKey = (e: NativeEventInfo<unknown, KeyboardEvent>) => {
    // Shift + Enter -> always new line
    if (e.event?.key !== 'Enter' || e.event?.shiftKey) {
      return;
    }

    const input = e.event.target as HTMLInputElement;
    const { value } = input;
    const hasManyLines = value.includes('\n');

    // just Enter:
    //  - if one-liner -> onAction
    //  - if multiline -> new line
    // Ctrl + Enter -> always onAction
    if (multiline && hasManyLines && !e.event.ctrlKey) {
      return;
    }

    e.event?.preventDefault();
    e.event?.stopPropagation();

    onAction();
  };
  return (
    <Styles>
      <NuvoBox display="flex" flexDirection="row" alignItems="stretch">
        {multiline ? (
          <TextArea
            disabled={disabled}
            autoResizeEnabled
            valueChangeEvent="keyup"
            onKeyDown={onEnterKey}
            {...txtProps}
          />
        ) : (
          <NuvoTextField
            disabled={disabled}
            valueChangeEvent="keyup"
            onEnterKey={onEnterKey}
            {...txtProps}
          />
        )}
        <TMMButton disabled={disabled} onClick={onAction} icon={icon} />
      </NuvoBox>
    </Styles>
  );
};

export default React.memo(ActionInput);
